import React from 'react'

const ClassMileStoneReport = () => {
  return (
    <div>
      
    </div>
  )
}

export default ClassMileStoneReport
